import React from "react";
import NewNavBar from "../navbar/new_navbar.js";
import Footer from "../footer/footer.js";
import { useLocation } from "react-router-dom";
import TargetText from "../targettext/target_text.js";
function Terms() {
  const location = useLocation();
  return (
    <div>
      <NewNavBar />
      <div className="pageD container">
        <TargetText name={location.pathname} />
        <div className="coverD">
          <div style={{ textAlign: "-webkit-center" }}>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
